<template>
    <div class="info-additional">
        <h3 class="cont-tit">이용안내</h3>
        <ol v-if="isNotEmpty(detailIntro)">
            <li v-if="isNotEmpty(detailIntro.playtime)">
                <b>[공연시간]</b> <br><p v-html="detailIntro.playtime"></p>
            </li>
            <li v-if="isNotEmpty(detailIntro.eventplace)">
                <b>[행사장소]</b> <br><p>{{detailIntro.eventplace}}</p>
            </li>
            <li v-if="isNotEmpty(detailIntro.usetimefestival)">
                <b>[이용시간]</b> <br><p v-html="detailIntro.usetimefestival"></p>
            </li>
            <li v-if="isNotEmpty(detailIntro.spendtimefestival)">
                <b>[관람소요시간]</b> <br><p v-html="detailIntro.spendtimefestival"></p>
            </li>
            <li v-if="isNotEmpty(detailIntro.agelimit)">
                <b>[관람가능연령]</b> <br><p>{{detailIntro.agelimit}}</p>
            </li>
            <li v-if="isNotEmpty(detailIntro.subevent)">
                <b>[부대행사]</b> <br><p>{{detailIntro.subevent}}</p>
            </li>
            <li v-if="isNotEmpty(detailIntro.program)">
                <b>[프로그램]</b> <br><p v-html="detailIntro.program"></p>
            </li>
            <li v-if="isNotEmpty(detailIntro.placeinfo)">
                <b>[행사장 위치안내]</b> <br><p v-html="detailIntro.placeinfo"></p>
            </li>
        </ol>
    </div>
</template>

<script>
export default {
    props: {
        detailIntro: { type: Object, default: null },
    }
}
</script>